import { createSlice } from "@reduxjs/toolkit";

const expensesSlice = createSlice({
  name: "expenses",
  initialState: {
    Expenses: [],
  },
  reducers: {
    expensesSuccess: (state, action) => {
      state.Expenses = action.payload;
    },

    clearExpenses: (state) => {
      state.Expenses = [];
    },
  },
});

export const { expensesSuccess, clearExpenses } = expensesSlice.actions;
export default expensesSlice.reducer;
